export const locationIntegrationsHandler = {
    pathPattern: '/brands/:brandId/locations/:locationId/settings/integrations',
    toWeb: ({ brandId, locationId }) => ({
        path: `/brands/${brandId}/locations/${locationId}/settings/integrations`,
    }),
    meta: {
        title: 'Location integrations settings',
        description: "Opens a location's integrations settings in the dashboard.",
        status: 'live',
        platforms: { web: true, ios: false, android: false },
        flag: null,
        params: [
            { name: 'brandId', in: 'path', required: true },
            { name: 'locationId', in: 'path', required: true },
        ],
        example: {
            params: {
                brandId: 'BXqExampleBrandId',
                locationId: 'exampleLocationId',
            },
        },
    },
};
//# sourceMappingURL=location-integrations.js.map